import { AccessGrant } from 'graphql/generated/graphqlTypes';
import { generateMockWeekSchedule } from './weekSchedule';

export function generateMockAccessGrant({
  accessSchedule = generateMockWeekSchedule({}),
  doors = [],
  doorIds = [],
  id = 'mockAccessGrantId',
  isOfficeModeEnabled = false,
  locations = [],
  locationIds = [],
  name = 'mockAccessGrantName',
  tenantId = 'mockAccessGrantTenantId'
}: Partial<Omit<AccessGrant, '__typename'>>): AccessGrant {
  return {
    __typename: 'AccessGrant',
    accessSchedule,
    doors,
    doorIds,
    id,
    isOfficeModeEnabled,
    locations,
    locationIds,
    name,
    tenantId
  };
}
